import { Box, Image, UnstyledButton } from "@dehub/theme";
import { renderBusinessName } from "@/utils/render-business-name";
import classes from "../business.module.css";

type Props = Readonly<{
  logo?: string | null;
  name?: string | null;
  nameEng?: string | null;
  onPreview?: (src: string, name: string) => void;
}>;

/** Square business logo; falls back to the first letters of the name. Click previews it. */
export function BusinessLogo({ logo, name, nameEng, onPreview }: Props) {
  const display = renderBusinessName({ profileName: name, profileNameEng: nameEng });
  const initials = display === "-" ? "" : display.replace(/\s+/g, "").slice(0, 2).toUpperCase();

  if (logo && onPreview) {
    return (
      <UnstyledButton
        className={`${classes.logo} ${classes.logoButton}`}
        aria-label={display}
        onClick={() => onPreview(logo, display)}
      >
        <Image src={logo} alt={display} w="100%" h="100%" fit="cover" />
      </UnstyledButton>
    );
  }

  return (
    <Box className={classes.logo} aria-hidden="true">
      {logo ? <Image src={logo} alt="" w="100%" h="100%" fit="cover" /> : initials}
    </Box>
  );
}
